import type { FaireProductEntity } from "../../entity_types/product";

export const p_m9ab4vrymx: FaireProductEntity = {
  token: "p_m9ab4vrymx",
  type: "product",
  name: "Squishy Glitter Baby (China)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/e038790690775d9b7d6843aafa352ddc838b3fb1d806df9a1b7068ab5ab649cf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6868e1907ce1a2285d2d7a712d00a99f9661eb516d1adad102bce225919ae23c.png",
  ],
  priceDollars: 3.72,
  description:
    "Squishy Glitter Baby is a soft sensory toy with a playful baby-shaped design and glitter-filled visual details. Its squeezable construction gives it a satisfying texture in the hand, while the decorative finish makes it equally appealing as a small display piece or collectible. The toy is well suited for fidgeting, stress relief, and light sensory play. Colors or designs may vary depending on the assortment.\n",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:47.698Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
